module.exports = __webpack_public_path__ + "img/gem5_color4.615a1ba4.png";